/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Skeleton } from '@mui/material';
import { FC } from 'react';

const SidebarNavSkeleton: FC = () => (
  <>
    <Skeleton height={38} animation="wave" />
    <Skeleton height={38} animation="wave" />
    <Skeleton height={38} animation="wave" />
  </>
);

export default SidebarNavSkeleton;
